export const LOAD_CENTRALIZED_ISSUES = 'LOAD_CENTRALIZED_ISSUES';
export const CHANGE_CENTRALIZES_ISSUES_LIST_OPTIONS = 'CHANGE_CENTRALIZES_ISSUES_LIST_OPTIONS';
export const SET_DETAILED_ISSUES_FOR_CENTRALIZED_VIEW = 'SET_DETAILED_ISSUES_FOR_CENTRALIZED_VIEW';
export const CLEAR_DETAILED_ISSUES_FOR_CENTRALIZED_VIEW = 'CLEAR_DETAILED_ISSUES_FOR_CENTRALIZED_VIEW';
export const TOGGLE_SUPPRESS_STATUS_FOR_ISSUE = 'TOGGLE_SUPPRESS_STATUS_FOR_ISSUE';
export const BULK_TOGGLE_SUPPRESS_STATUS_FOR_ISSUES = 'BULK_TOGGLE_SUPPRESS_STATUS_FOR_ISSUES';
export const CLEAR_CENTRALIZED_ISSUES_LIST_OPTIONS = 'CLEAR_CENTRALIZED_ISSUES_LIST_OPTIONS';
export const SET_OPEN_DETAILED_ISSUES_POPUP = 'SET_OPEN_DETAILED_ISSUES_POPUP';
